<template>
  <div>
    <div v-if="isMinimized" class="minimizedList style-3">
      <div
        class="suggestItem d-flex"
        v-for="(item, suggestIndex) in suggestionsList"
        :key="suggestIndex"
      >
        <div class="mx-auto">
          <div class="suggestImgItem" @click="navigatePage(item)">
            <img :src="item.logo" class="suggestImage" />
          </div>
          <div class="d-flex">
            <div v-if="item.facebook">
              <a
                class="link suggestionIcons"
                :href="item.facebook"
                target="_blank"
              >
                <i class="fa fa-facebook-square" aria-hidden="true"></i>
              </a>
            </div>
            <div v-if="item.linkedin">
              <a
                class="link suggestionIcons"
                :href="item.linkedin"
                target="_blank"
              >
                <i class="fa fa-linkedin-square" aria-hidden="true"></i>
              </a>
            </div>
            <div v-if="item.twitter">
              <a
                class="link suggestionIcons"
                :href="item.twitter"
                target="_blank"
              >
                <i class="fa fa-twitter-square" aria-hidden="true"></i>
              </a>
            </div>
          </div>
          <div
            style="margin-top: 5px"
            v-if="item.investors && item.investors.length > 0"
            class="d-flex"
          >
            <div v-for="(investor, index) in item.investors" :key="index">
              <div
                class="suggestionConnectionImagesDiv"
                :style="index == 0 ? '' : 'margin-left:-18px;'"
                v-if="index <= 2"
              >
                <img
                  class="suggestionConnectionImages"
                  v-if="investor.image"
                  :src="getImageUrl(investor.image)"
                  :id="'profile' + investor.master_pid + index + suggestIndex"
                />
                <b-avatar
                  v-else
                  :text="avatarText(investor.value)"
                  class="align-baseline suggestionAvatar"
                  :id="'profile' + investor.master_pid + index + suggestIndex"
                  :title="investor.value ? investor.value : ''"
                  :style="`background:${pickBackgroundColor(
                    investor.value
                  )};min-width:100%;min-height:100%;border-radius:50%`"
                ></b-avatar>
                <b-popover
                  :target="
                    'profile' + investor.master_pid + index + suggestIndex
                  "
                  triggers="hover"
                  placement="topright"
                  custom-class
                >
                  <div>
                    <div class="row">
                      <div class="col-4 peoplePopOverImage">
                        <img
                          width="77"
                          height="77"
                          class="rounded-circle"
                          v-bind:src="`${
                            investor.image && investor.image.length > 0
                              ? getImageUrl(investor.image)
                              : 'static/img/faces/face-0.jpg'
                          }`"
                        />
                      </div>
                      <div class="col-8">
                        <div class="peoplePopoverName">{{ investor.name }}</div>
                        <div v-if="investor.job_title" style>
                          {{ investor.job_title }}
                        </div>
                        <div v-if="investor.city">{{ investor.city }}</div>
                        <div class="d-flex">
                          <div v-if="investor.facebook">
                            <a
                              class="link peoplePopOverSocialMedia"
                              :href="investor.facebook"
                              target="_blank"
                            >
                              <i
                                class="fa fa-facebook-square"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </div>
                          <div v-if="investor.linkedin">
                            <a
                              class="link peoplePopOverSocialMedia"
                              :href="investor.linkedin"
                              target="_blank"
                            >
                              <i
                                class="fa fa-linkedin-square"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </div>
                          <div v-if="investor.twitter">
                            <a
                              class="link peoplePopOverSocialMedia"
                              :href="investor.twitter"
                              target="_blank"
                            >
                              <i
                                class="fa fa-twitter-square"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex" style="justify-content: space-between">
                      <div v-if="investor.num_portfolio_organization">
                        <div class="popoverTitleCls">Portfolio</div>
                        <div class="popoverValueCls">
                          {{ investor.num_portfolio_organization }}
                        </div>
                      </div>
                      <div v-if="investor.num_exits">
                        <div class="popoverTitleCls">Exits</div>
                        <div class="popoverValueCls">
                          {{ investor.num_exits }}
                        </div>
                      </div>
                      <div
                        v-if="
                          investor.investedCompanies &&
                          investor.investedCompanies.length
                        "
                      >
                        <div class="popoverTitleCls">Co-invested</div>
                        <div class="popoverValueCls">
                          {{ investor.investedCompanies.length }}
                        </div>
                      </div>
                    </div>
                  </div>
                </b-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <b-dropdown
        size="lg"
        variant="link"
        ref="filterRef"
        toggle-class="text-decoration-none suggestionFilterBtn"
        class="suggestionFilterDrpdwn"
        offset="-100"
        no-caret
        style="right: 0px; position: absolute"
      >
        <template v-slot:button-content>
          <img src="static/img/filter.svg" class="mr-1" />
        </template>
        <b-dropdown-form class="suggestionForm">
          <div class="pl-4 pt-1" style="border-bottom: 1px solid #00000029">
            <div class="d-flex mb-3" v-for="item of filters" :key="item.name">
              <input
                type="checkbox"
                class="regular-checkbox mr-2"
                style="cursor: pointer"
                v-model="item.checked"
              />
              <div class="checkFieldCls">{{ item.name }}</div>
            </div>
          </div>
          <div class="filterFormBtns d-flex">
            <button
              class="newTask"
              style="border: 0px; cursor: pointer"
              @click="clearAll"
            >
              Clear all
            </button>
            <button
              class="newTask"
              style="border: 0px; cursor: pointer"
              @click="apply"
            >
              Apply
            </button>
          </div>
        </b-dropdown-form>
      </b-dropdown>
      <b-tabs content-class="mt-3">
        <b-tab
          title="YOU MIGHT BE INTERESTED"
          active-nav-item-class="pl-5"
          active
        >
          <div class="text-center mt-5" v-if="isLoading">
            <b-spinner
              style="width: 6rem; height: 6rem; color: #5445f3"
              class="mt-5"
              label="Large Spinner"
            ></b-spinner>
          </div>
          <div
            class="parentPaddingItem style-3"
            v-else-if="suggestionsList && suggestionsList.length > 0"
          >
            <div
              class="suggestItem"
              v-for="(item, suggestIndex) in suggestionsList"
              :key="suggestIndex"
            >
              <div class="d-flex">
                <div class style="padding-right: 24px">
                  <div>
                    <div class="suggestImgItem" @click="navigatePage(item)">
                      <img :src="item.logo" class="suggestImage" />
                    </div>
                    <div class="d-flex">
                      <div v-if="item.facebook">
                        <a
                          class="link suggestionIcons"
                          :href="item.facebook"
                          target="_blank"
                        >
                          <i
                            class="fa fa-facebook-square"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                      <div v-if="item.linkedin">
                        <a
                          class="link suggestionIcons"
                          :href="item.linkedin"
                          target="_blank"
                        >
                          <i
                            class="fa fa-linkedin-square"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                      <div v-if="item.twitter">
                        <a
                          class="link suggestionIcons"
                          :href="item.twitter"
                          target="_blank"
                        >
                          <i
                            class="fa fa-twitter-square"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="d-flex">
                    <div class="suggestionName" @click="navigatePage(item)">
                      {{ item.name }}
                    </div>
                    <div v-if="item.ltseCompany" class="ml-2">
                      <img src="static/img/suggestionLTSE.png" />
                    </div>
                  </div>
                  <div class="suggestionDesc">{{ item.description }}</div>
                  <div class="d-flex pt-2">
                    <div class="suggestionDesc">{{ item.categories }}</div>
                  </div>
                </div>
                <div
                  style="cursor: pointer"
                  :title="`Archive ${item.name}`"
                  @click="archiveSuggestion(item, suggestIndex)"
                >
                  <i class="fas fa-times"></i>
                </div>
              </div>
              <div
                style="margin-top: 5px"
                v-if="item.investors && item.investors.length > 0"
                class="d-flex"
              >
                <div v-for="(investor, index) in item.investors" :key="index">
                  <div
                    class="suggestionConnectionImagesDiv"
                    :style="index == 0 ? '' : 'margin-left:-18px;'"
                    v-if="index <= 2"
                  >
                    <img
                      class="suggestionConnectionImages"
                      v-if="investor.image"
                      :src="getImageUrl(investor.image)"
                      :id="
                        'profile' + investor.master_pid + index + suggestIndex
                      "
                    />
                    <b-avatar
                      v-else
                      :text="avatarText(investor.value)"
                      class="align-baseline suggestionAvatar"
                      :id="
                        'profile' + investor.master_pid + index + suggestIndex
                      "
                      :title="investor.value ? investor.value : ''"
                      :style="`background:${pickBackgroundColor(
                        investor.value
                      )};min-width:100%;min-height:100%;border-radius:50%`"
                    ></b-avatar>
                    <b-popover
                      :target="
                        'profile' + investor.master_pid + index + suggestIndex
                      "
                      triggers="hover"
                      placement="topright"
                      custom-class
                    >
                      <div>
                        <div class="row">
                          <div class="col-4 peoplePopOverImage">
                            <img
                              width="77"
                              height="77"
                              class="rounded-circle"
                              v-bind:src="`${
                                investor.image && investor.image.length > 0
                                  ? getImageUrl(investor.image)
                                  : 'static/img/faces/face-0.jpg'
                              }`"
                            />
                          </div>
                          <div class="col-8">
                            <div class="peoplePopoverName">
                              {{ investor.name }}
                            </div>
                            <div v-if="investor.job_title" style>
                              {{ investor.job_title }}
                            </div>
                            <div v-if="investor.city">{{ investor.city }}</div>
                            <div class="d-flex">
                              <div v-if="investor.facebook">
                                <a
                                  class="link peoplePopOverSocialMedia"
                                  :href="investor.facebook"
                                  target="_blank"
                                >
                                  <i
                                    class="fa fa-facebook-square"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>
                              <div v-if="investor.linkedin">
                                <a
                                  class="link peoplePopOverSocialMedia"
                                  :href="investor.linkedin"
                                  target="_blank"
                                >
                                  <i
                                    class="fa fa-linkedin-square"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>
                              <div v-if="investor.twitter">
                                <a
                                  class="link peoplePopOverSocialMedia"
                                  :href="investor.twitter"
                                  target="_blank"
                                >
                                  <i
                                    class="fa fa-twitter-square"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex"
                          style="justify-content: space-between"
                        >
                          <div v-if="investor.num_portfolio_organization">
                            <div class="popoverTitleCls">Portfolio</div>
                            <div class="popoverValueCls">
                              {{ investor.num_portfolio_organization }}
                            </div>
                          </div>
                          <div v-if="investor.num_exits">
                            <div class="popoverTitleCls">Exits</div>
                            <div class="popoverValueCls">
                              {{ investor.num_exits }}
                            </div>
                          </div>
                          <div
                            v-if="
                              investor.investedCompanies &&
                              investor.investedCompanies.length
                            "
                          >
                            <div class="popoverTitleCls">Co-invested</div>
                            <div class="popoverValueCls">
                              {{ investor.investedCompanies.length }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-popover>
                  </div>
                </div>
                <div class="otherInvestedCls" v-if="item.investors.length > 3">
                  <span style="text-decoration: underline">{{
                    item.investors.length - 3
                  }}</span>
                  {{
                    item.investors.length == 4 ? "connection" : "connections"
                  }}
                  Invested
                </div>
              </div>
            </div>
          </div>
          <div class="notifyPlaceholder" v-else>No records to view</div>
        </b-tab>
        <b-tab title="ARCHIVE">
          <div class="text-center mt-5" v-if="isLoading">
            <b-spinner
              style="width: 6rem; height: 6rem; color: #5445f3"
              class="mt-5"
              label="Large Spinner"
            ></b-spinner>
          </div>
          <div
            class="parentPaddingItem style-3"
            v-else-if="archivedDataList && archivedDataList.length > 0"
          >
            <div
              class="suggestItem"
              v-for="(item, suggestIndex) in archivedDataList"
              :key="suggestIndex"
            >
              <div class="d-flex">
                <div class style="padding-right: 24px">
                  <div>
                    <div class="suggestImgItem" @click="navigatePage(item)">
                      <img :src="item.logo" class="suggestImage" />
                    </div>
                    <div class="d-flex">
                      <div v-if="item.facebook">
                        <a
                          class="link suggestionIcons"
                          :href="item.facebook"
                          target="_blank"
                        >
                          <i
                            class="fa fa-facebook-square"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                      <div v-if="item.linkedin">
                        <a
                          class="link suggestionIcons"
                          :href="item.linkedin"
                          target="_blank"
                        >
                          <i
                            class="fa fa-linkedin-square"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                      <div v-if="item.twitter">
                        <a
                          class="link suggestionIcons"
                          :href="item.twitter"
                          target="_blank"
                        >
                          <i
                            class="fa fa-twitter-square"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="suggestionName" @click="navigatePage(item)">
                    {{ item.name }}
                  </div>
                  <div class="suggestionDesc">{{ item.description }}</div>
                  <div class="d-flex pt-2">
                    <div class="suggestionDesc">{{ item.categories }}</div>
                  </div>
                </div>
                <div
                  style="cursor: pointer"
                  :title="`Restore ${item.name}`"
                  @click="restore(item, suggestIndex)"
                >
                  <span class="material-icons">restore</span>
                </div>
              </div>
              <div
                style="margin-top: 5px"
                v-if="item.investors && item.investors.length > 0"
                class="d-flex"
              >
                <div v-for="(investor, index) in item.investors" :key="index">
                  <div
                    class="suggestionConnectionImagesDiv"
                    :style="index == 0 ? '' : 'margin-left:-18px;'"
                    v-if="index <= 2"
                  >
                    <img
                      class="suggestionConnectionImages"
                      v-if="investor.image"
                      :src="getImageUrl(investor.image)"
                      :id="
                        'profile' + investor.master_pid + index + suggestIndex
                      "
                    />
                    <b-avatar
                      v-else
                      :text="avatarText(investor.value)"
                      class="align-baseline suggestionAvatar"
                      :id="
                        'profile' + investor.master_pid + index + suggestIndex
                      "
                      :title="investor.value ? investor.value : ''"
                      :style="`background:${pickBackgroundColor(
                        investor.value
                      )};min-width:100%;min-height:100%;border-radius:50%`"
                    ></b-avatar>
                    <b-popover
                      :target="
                        'profile' + investor.master_pid + index + suggestIndex
                      "
                      triggers="hover"
                      placement="topright"
                      custom-class
                    >
                      <div>
                        <div class="row">
                          <div class="col-4 peoplePopOverImage">
                            <img
                              width="77"
                              height="77"
                              class="rounded-circle"
                              v-bind:src="`${
                                investor.image && investor.image.length > 0
                                  ? getImageUrl(investor.image)
                                  : 'static/img/faces/face-0.jpg'
                              }`"
                            />
                          </div>
                          <div class="col-8">
                            <div class="peoplePopoverName">
                              {{ investor.name }}
                            </div>
                            <div v-if="investor.job_title" style>
                              {{ investor.job_title }}
                            </div>
                            <div v-if="investor.city">{{ investor.city }}</div>
                            <div class="d-flex">
                              <div v-if="investor.facebook">
                                <a
                                  class="link peoplePopOverSocialMedia"
                                  :href="investor.facebook"
                                  target="_blank"
                                >
                                  <i
                                    class="fa fa-facebook-square"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>
                              <div v-if="investor.linkedin">
                                <a
                                  class="link peoplePopOverSocialMedia"
                                  :href="investor.linkedin"
                                  target="_blank"
                                >
                                  <i
                                    class="fa fa-linkedin-square"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>
                              <div v-if="investor.twitter">
                                <a
                                  class="link peoplePopOverSocialMedia"
                                  :href="investor.twitter"
                                  target="_blank"
                                >
                                  <i
                                    class="fa fa-twitter-square"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex"
                          style="justify-content: space-between"
                        >
                          <div v-if="investor.num_portfolio_organization">
                            <div class="popoverTitleCls">Portfolio</div>
                            <div class="popoverValueCls">
                              {{ investor.num_portfolio_organization }}
                            </div>
                          </div>
                          <div v-if="investor.num_exits">
                            <div class="popoverTitleCls">Exits</div>
                            <div class="popoverValueCls">
                              {{ investor.num_exits }}
                            </div>
                          </div>
                          <div
                            v-if="
                              investor.investedCompanies &&
                              investor.investedCompanies.length
                            "
                          >
                            <div class="popoverTitleCls">Co-invested</div>
                            <div class="popoverValueCls">
                              {{ investor.investedCompanies.length }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-popover>
                  </div>
                </div>
                <div class="otherInvestedCls" v-if="item.investors.length > 3">
                  <span style="text-decoration: underline">{{
                    item.investors.length - 3
                  }}</span>
                  {{
                    item.investors.length == 4 ? "connection" : "connections"
                  }}
                  Invested
                </div>
              </div>
            </div>
          </div>
          <div class="notifyPlaceholder mt-2" v-else>No records to view</div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import api from "../../../axios_api";
import { mapGetters } from "vuex";
import { pickBackgroundColor } from "../../../util/index";
import config from "../../../../config/settings";
export default {
  computed: {
    ...mapGetters("suggestions", [
      "suggestions",
      "archivedList",
      "userFilters",
    ]),
    ...mapGetters("portfolio", ["portfolioAll", "portfolioCount"]),
    ...mapGetters("workspacePlans", ["feature", "plan"]),
    filters() {
      let list = [
        { name: "sector", checked: false },
        { name: "stage", checked: false },
      ];
      if (this.plan && this.plan.toLowerCase() != "free") {
        list.push({ name: "connections", checked: false });
      }
      return list;
    },
  },
  data() {
    return {
      suggestionsList: [],
      archivedDataList: [],
      isLoading: false,
    };
  },
  props: {
    isMinimized: Boolean,
  },
  mounted() {
    this.intializeSuggestions("mounted");
    let userFilters = this.userFilters;
    for (let key in userFilters) {
      this.filters.map((item) => {
        if (item.name == key) item.checked = userFilters[key];
      });
    }
  },
  watch: {
    suggestions: _.debounce(function (data) {
      if (data) {
        this.intializeSuggestions("watch");
      }
    }),
    userFilters: function () {
      for (let key in this.userFilters) {
        this.filters.map((item) => {
          if (item.name == key) item.checked = this.userFilters[key];
        });
      }
    },
  },
  methods: {
    apply(e) {
      e.preventDefault();
      let self = this;
      self.isLoading = true;
      let filterObj = {};
      this.filters.map((item) => {
        filterObj[item.name] = item.checked;
      });
      let userFilters = JSON.stringify(this.userFilters);
      let givenFilters = JSON.stringify(filterObj);
      if (userFilters == givenFilters) {
        self.isLoading = false;
        self.$refs.filterRef.hide();
      } else {
        self.$store.commit("suggestions/setUserFilters", filterObj);
        self.$store
          .dispatch("suggestions/getSuggestions")
          .then((data) => {
            self.isLoading = false;
            self.$refs.filterRef.hide();
          })
          .catch((err) => {
            self.isLoading = false;
            console.log("fail to get suggestions", { err });
          });
      }
    },
    clearAll(e) {
      e.preventDefault();
      let self = this;
      let check = false;
      self.isLoading = true;
      let filterObj = {};
      this.filters.map((item) => {
        if (item.checked) check = true;
        item.checked = false;
        filterObj[item.name] = item.checked;
      });
      let userFilters = JSON.stringify(this.userFilters);
      let givenFilters = JSON.stringify(filterObj);
      if (userFilters == givenFilters) {
        self.isLoading = false;
        self.$refs.filterRef.hide();
      } else {
        self.$store.commit("suggestions/setUserFilters", filterObj);
        self.$store.dispatch("suggestions/getSuggestions").then((data) => {
          self.isLoading = false;
          self.$refs.filterRef.hide();
        });
      }
    },
    intializeSuggestions(type) {
      let list = {},
        archives = {},
        self = this;
      if (
        self.$route.params.workspace_id == "5f34ec899f89fd2a7c3dafc2" ||
        self.$route.params.workspace_id == "5f481126524d4f4fcedbf81b"
      ) {
        let pallabyObj = {
          headquarters: "	Santa Monica,California,United States,North America",
          categories:
            "Commerce and Shopping,Community and Lifestyle,Consumer Goods",
          linkedin: "https://www.linkedin.com/company/pallaby/",
          twitter: "https://twitter.com/pallabypet",
          description:
            "Pallaby, a direct-to-consumer pet food company that delivers pre-portioned pet food journeys, tailored for the individual pet, backed by vets, based on pet's changing needs over time.",
          name: "pallaby",
          permalink: "pallaby",
          facebook: "https://www.instagram.com/pallabypet/",
          logo:
            "https://res.cloudinary.com/crunchbase-production/image/upload/qg76rjk5mylek00bdqkj",
          ltseCompany: true,
        };
        this.suggestions.unshift(pallabyObj);
      }
      let companies = JSON.parse(JSON.stringify(this.portfolioAll));
      if (this.archivedList && this.archivedList.length) {
        companies = companies.concat(this.archivedList);
      }
      this.suggestions.map((item) => {
        if (item.permalink) {
          let index = companies.findIndex((portfolioItem) => {
            if (
              portfolioItem.permalink &&
              portfolioItem.permalink == item.permalink
            ) {
              return portfolioItem;
            }
          });
          if (index < 0 && !list[item.permalink]) {
            list[item.permalink] = item;
          }
        }
      });
      self.suggestionsList = Object.values(list);
      if (type == "mounted") {
        this.archivedList.map((item) => {
          if (item.permalink) {
            let index = this.portfolioAll.findIndex((portfolioItem) => {
              if (
                portfolioItem.permalink &&
                portfolioItem.permalink == item.permalink
              ) {
                return portfolioItem;
              }
            });
            if (index < 0 && !archives[item.permalink]) {
              archives[item.permalink] = item;
            }
          }
        });
        self.archivedDataList = Object.values(archives);
      }
    },
    restore(data, index) {
      let self = this;
      let payload = {
        permalink: data.permalink,
        name: data.name,
        linkedin: data.linkedin,
        twitter: data.twitter,
        facebook: data.facebook,
        google: data.google,
        logo: data.logo,
        headquarters: data.headquarters,
        categories: data.categories,
        description: data.description,
        investors: data.investors,
        account: self.$route.params.account_id,
        _id: data._id,
        uuid: data.uuid,
        isArchived: true,
      };
      this.$store
        .dispatch("suggestions/apiArchiveSuggestion", payload)
        .then((resp) => {
          let list = {};
          self.suggestionsList.unshift(payload);
          self.suggestionsList.map((item) => {
            let index = self.portfolioAll.findIndex((portfolioItem) => {
              if (
                portfolioItem.permalink &&
                portfolioItem.permalink == item.permalink
              ) {
                return portfolioItem;
              }
            });

            if (index <= 0 && !list[item.permalink]) {
              list[item.permalink] = item;
            }
          });
          self.suggestionsList = Object.values(list);
          self.$store.commit(
            "suggestions/suggestionsInterestedMerge",
            self.suggestionsList
          );
          self.archivedDataList.splice(index, 1);
          self.$store.commit("suggestions/archiveMerge", self.archivedDataList);
        })
        .catch((err) => {});
    },
    archiveSuggestion(data, index) {
      let self = this;
      let payload = {
        permalink: data.permalink,
        name: data.name,
        linkedin: data.linkedin,
        twitter: data.twitter,
        facebook: data.facebook,
        google: data.google,
        logo: data.logo,
        headquarters: data.headquarters,
        categories: data.categories,
        description: data.description,
        investors: data.investors,
        account: self.$route.params.account_id,
        uuid: data.uuid,
        isArchived: false,
      };
      this.$store
        .dispatch("suggestions/apiArchiveSuggestion", payload)
        .then((resp) => {
          let archives = {};
          resp.map((item) => {
            if (item.permalink) {
              let index = self.portfolioAll.findIndex((portfolioItem) => {
                if (
                  portfolioItem.permalink &&
                  portfolioItem.permalink == item.permalink
                ) {
                  return portfolioItem;
                }
              });
              if (index < 0 && !archives[item.permalink]) {
                archives[item.permalink] = item;
              }
            }
          });
          self.archivedDataList = Object.values(archives);
          self.$store.commit("suggestions/archiveMerge", self.archivedDataList);
          self.suggestionsList.splice(index, 1);
          self.$store.commit(
            "suggestions/suggestionsInterestedMerge",
            self.suggestionsList
          );
        })
        .catch((err) => {});
    },
    pickBackgroundColor: pickBackgroundColor,
    avatarText(title) {
      let text = title.split(" ");
      text =
        text.length > 1
          ? `${text[0].charAt(0)}${text[1].charAt(0)}`
          : text[0].charAt(0);

      return text;
    },
    navigatePage(item) {
      this.$router.push(
        `/${this.$route.params.account_id}/shared/company?permalink=${item.permalink}&diligence=true&workspace_id=${this.$route.params.workspace_id}`
      );
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },
  },
};
</script>
<style>
.minimizedList {
  overflow: auto;
  height: 100vh;
}
.suggestionFilterBtn {
  padding-top: 0px;
  padding-bottom: 0px;
}
.suggestionFilterDrpdwn .dropdown-menu {
  background: #ffffff 0% 0% no-repeat padding-box;
  -webkit-box-shadow: 0px 3px 8px #00000029;
  box-shadow: 0px 3px 8px #00000029;
  border-radius: 4px;
  border: 0;
  padding-top: 10px;
  padding-bottom: 0px;
}
.suggestionFilterDrpdwn {
  position: absolute;
  right: 0px;
}
.suggestionForm .b-dropdown-form {
  padding: 0px;
}
.suggestionTitle {
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.41;
  font-size: 12px;
  line-height: 50px;
  text-align: left;
  text-transform: uppercase;
  padding-left: 30px;
}
.parentPaddingItem {
  padding-left: 36px;
  padding-right: 36px;
  height: 100vh;
  overflow: auto;
}
.suggestImgItem {
  width: 64px;
  height: 64px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 5px;
  cursor: pointer;
}
.suggestItem {
  padding-top: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #00000033;
}

.suggestionDesc {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  line-height: 20px;
}

.suggestionIcons {
  color: #0000009a !important;
  font-size: 18px;
  padding-right: 5px;
}

.suggestionConnectionImagesDiv {
  display: inline-block;
  position: relative;
  width: 36px;
  height: 36px;
  overflow: hidden;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.18);
}

.suggestionConnectionImages {
  width: auto;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  display: inline-block;
}

.otherInvestedCls {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 25px;
}
.suggestImage {
  height: 100%;
  width: 100%;
}

.suggestionAvatar .b-avatar-text {
  font-size: 16px !important;
  color: #000000;
  margin-bottom: 8px !important;
}
</style>
